import { IApplicationState } from '../../../../../types/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';

export const getHideMyWorkColumnsTitle = (
    state: IApplicationState
): boolean => {
    return getAuthUserMetaMyWork(state).isHideColumnsTitle;
};
